const AirportDetailsSections = () => {
    return <></>
}

export default AirportDetailsSections;